import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterUser_template} from "./filterUser_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterTag_template} from "./filterTag_template";
import {filterArticle_template} from "./filterArticle_template";
import {imagePicker_template_mockup} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template_mockup';

declare var ko: any;

export class articleContent_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

                <div class="section-content full-width" data-bind="attr: { id: idElement }">
                    <!-- ----------------- -->
                    <!-- CONTENT          -->
                    <!-- ----------------- -->

                     <div class="form-group">
                        <textarea data-bind="disable: isEditorDisable(), attr: {id: editorId()}"></textarea>
                     </div>
                </div>

      `;
    }

    protected initPartial():void{

        this.getTemplateViewModel().editorId();
    }



    protected getTemplateName(): string{

        return "articleContent_template";
    }

    protected buildViewModel(): any{

        let self = this;

        return{
            editorId: ko.observable(this.idElement.replace("_section", "")),
            idElement: ko.observable(this.idElement),
            idTemplate: ko.observable(null),
            idStatus: ko.observable(null),
            reviewItems: ko.observableArray([]),
            reviewItemsToDelete: ko.observableArray([]),
            introText: ko.observable(""),
            selectedTab: ko.observable('article'),
            isReviewItemDeleteVisible: ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['article_edit_takeover', 'article_edit_publishingControl'])),
            onClickEditReviewItem: function (value, data, event) {self.onClickEditReviewItem(value);},
            onClickAddProduct: function (value, data, event) {self.caller.showReviewItemForm();},
            onClickDeleteReviewItem: function (value, data, event) {self.onClickDeleteReviewItem(value);},
            onClickConfirmReviewItemDelete: function (value, data, event) {self.onClickConfirmReviewItemDelete();},
            onClickCancelReviewItemDelete: function (value, data, event) {self.onClickCancelReviewItemDelete();},
            isEditorDisable: function (value, event) { self.isEditorDisable(); }
        }
    }

    public getViewModelForRequest(){

        return{

        }
    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public getReviewItems() {

        return this.getTemplateViewModel().reviewItems();
    }

    public setSelectedTab(selectedTab) {

        this.getTemplateViewModel().selectedTab(selectedTab);
    }

    public setIdTemplate(idTemplate): void{

        this.getTemplateViewModel().idTemplate(idTemplate);
    }

    public setIdStatus(idStatus): void{

        this.getTemplateViewModel().idStatus(idStatus);
    }

    public setEditorId(editorId): void{

        this.getTemplateViewModel().editorId(editorId);
    }

    public getIdTemplate(): void{

        return this.getTemplateViewModel().idTemplate();
    }

    public setReviewItems(reviewItems): void{

        for(let i = 0; i < reviewItems.length; i++){
            reviewItems[i].tagAwardClass = reviewItems[i].award ? 'i-' + reviewItems[i].award.name.replace(' ', '-').toLowerCase() : "";
            reviewItems[i].idTagType = reviewItems[i].tag ? reviewItems[i].tag.idType: 0;
        }

        this.getTemplateViewModel().reviewItems(reviewItems);
        this.onLoadTemplate('#review-item-list .img-article-item', this.reorderReviewItems.bind(this));
    }

    private onLoadTemplate (dragItemSelector, sortFunction) {

        var parent = this;

        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for(let item of dragItems){
                if(dragSrcEl == item){

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if(this == item){

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if(!found){
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if(dropHTML.includes("<li")){
                    for(let child of this.parentNode.childNodes){

                        if(child == dragSrcEl){
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if(this.classList.contains("before")){
                        this.insertAdjacentHTML('beforebegin',dropHTML);
                        var dropElem = this.previousElementSibling;
                    }else{
                        this.insertAdjacentHTML('afterend',dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItems(huit_neuf_this){
        let reviewItems = [];
        reviewItems = huit_neuf_this.getTemplateViewModel().reviewItems();

        let selector = '#review-item-list .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newReviewItems = []
        for(let element of liElements){

            let idElement = element.id;
            let reviewItem = reviewItems.find((i, index) => index === Number(element.id));
            if(reviewItem){
                newReviewItems.push(reviewItem);
            }
        }

        huit_neuf_this.getTemplateViewModel().reviewItems([]);
        huit_neuf_this.getTemplateViewModel().reviewItems(newReviewItems);
        huit_neuf_this.onLoadTemplate(selector, this.reorderReviewItems.bind(huit_neuf_this));
    }


    protected onClickConfirmReviewItemDelete() {

        let idElement = this.getTemplateViewModel().reviewItemToDelete();
        this.setIsReviewItemDeleteVisible(false);

        let index = this.getTemplateViewModel().reviewItems().findIndex(element => (element.id == idElement));
        if (index > -1) {
            this.getTemplateViewModel().reviewItems.splice(index, 1);
        }
        this.onLoadTemplate('#review-item-list .img-article-item', this.reorderReviewItems);
        this.getTemplateViewModel().reviewItemToDelete(null);
        this.getTemplateViewModel().reviewItemsToDelete.push(idElement)
    }

    protected onClickCancelReviewItemDelete() {

        this.setIsReviewItemDeleteVisible(false);
    }

    public setIsReviewItemDeleteVisible(value) {

        this.getTemplateViewModel().isReviewItemDeleteVisible(value);
    }

    protected onClickDeleteReviewItem(data) {

        this.getTemplateViewModel().reviewItemsToDelete(data.id);
        this.setIsReviewItemDeleteVisible(true);
    }

    public onClickEditReviewItem(reviewItem) {

        this.caller.onClickEditReviewItem(reviewItem)
    }

    public isEditorDisable() {

        let result = false;
        if(this.getTemplateViewModel().idStatus() == 6 && !this.getTemplateViewModel().permissions()['article_edit_publishingControl'].write && this.getTemplateViewModel().selectedTab() == 'article' && !this.idElement.toLowerCase().includes('sandbox')){
            result = true;
        }

        if (this.idElement.toLowerCase().includes('sandbox')) {
            this.caller.setSandboxEditorStatus(result)
        } else if (this.idElement.toLowerCase().includes('republish')) {
            this.caller.setRepublishEditorStatus(result)
        }
        else {
            this.caller.setContentEditorStatus(result)
        }
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/articleContent_template.ts